import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Box, DataGrid, Stack, Typography, Button } from '../../ui/core';
import { cardHeaderSx, filterPillSx, pillButtonSx } from '../../ui/styles';
import { fetchVehicles, setSelectedVehicle } from '../../redux/Fleet/actions';
import AddVehicleDialog from '../../components/widgets/Fleet/AddVehicleDialog';
import VehicleDetailsDialog from '../../components/widgets/Fleet/VehicleDetailsDialog';
import AssignTripDialog from '../../components/widgets/Fleet/AssignTripDialog';
import { VehicleColumns } from '../../models/Fleet';

// Fixed page size rather than one derived from window.innerHeight — decouples
// the row-fetch size from how much chrome sits above the grid.
const PAGE_SIZE = 25;

const FleetVehiclesTable = () => {
  const dispatch = useDispatch();
  const { data, loading } = useSelector((state) => state.fleet.vehicles);
  const selection = useSelector((state) => state.fleet.selection);
  const [showAddDialog, setShowAddDialog] = useState(false);
  const [showAssignDialog, setShowAssignDialog] = useState(false);

  useEffect(() => {
    fetchVehicles()(dispatch);
  }, [dispatch]);

  const onRowClick = ({ row }) => {
    setSelectedVehicle(data.find((v) => v.id === row.id))(dispatch);
  };

  const onDetailsClose = () => {
    setSelectedVehicle(null)(dispatch);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Box sx={cardHeaderSx}>
        <Stack direction="row" spacing={2} alignItems="center">
          <Typography sx={{ fontSize: '19px', fontWeight: 600, letterSpacing: '-0.01em', flex: 1 }}>
            Fleet Vehicles
          </Typography>
          <Button onClick={() => setShowAssignDialog(true)} sx={filterPillSx}>
            Assign Vehicle to Trip
          </Button>
          <Button onClick={() => setShowAddDialog(true)} sx={pillButtonSx}>
            + Add Vehicle
          </Button>
        </Stack>
      </Box>
      <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ flex: 1, minHeight: 0, position: 'relative' }}>
          <DataGrid
            rows={data}
            columns={VehicleColumns}
            onRowClick={onRowClick}
            pageSize={PAGE_SIZE}
            rowsPerPageOptions={[PAGE_SIZE]}
            loading={loading}
          />
        </Box>
      </Box>
      {selection && (
        <VehicleDetailsDialog vehicle={selection} onClose={onDetailsClose} />
      )}
      {showAddDialog && (
        <AddVehicleDialog onClose={() => setShowAddDialog(false)} />
      )}
      {showAssignDialog && (
        <AssignTripDialog onClose={() => setShowAssignDialog(false)} />
      )}
    </Box>
  );
};

export default FleetVehiclesTable;
